import { type CurrencyCode } from "common/types/mainTypes";
import { CurrencyCodeEnum } from "common/data/graphql/Enums/currency";

export const DEFAULT_BASE_MONEY_PROPS = {
  amount: 0,
  currency: CurrencyCodeEnum.USD as CurrencyCode,
  precision: 2,
};

// Example: Dinero({ amount: 500050 })	'$0,0'	$5,001
export const COMMA_SEP_WHOLE_NUMBER_FMT = "$0,0";

// Example: Dinero({ amount: 500050 })  '$0,0.00' $5,000.50
export const COMMA_SEP_W_DEC_FMT = "$0,0.00";
